/* Tomorrow Beyond — smooth scroll for [data-scroll-target] buttons and
   cross-page hash links (e.g. /#humanos from the navigation menu).
   Horizon scrolls an inner container (html/body are overflow:hidden) and
   intercepts anchor navigation, so native hash scrolling does not work.
   setTimeout-driven animation (not rAF): keeps working even when the tab
   is backgrounded and render-driven animations are throttled. */
(function () {
  var HEADER_OFFSET = 90;

  function findScroller(target) {
    var el = target.parentElement;
    while (el) {
      var o = getComputedStyle(el).overflowY;
      if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight) return el;
      el = el.parentElement;
    }
    return document.scrollingElement;
  }

  function scrollToTarget(target, duration) {
    var scroller = findScroller(target);
    var to = Math.max(
      scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top - HEADER_OFFSET,
      0
    );
    var from = scroller.scrollTop;
    var dur = duration || 900;
    var t0 = performance.now();
    var prevBehavior = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    (function step() {
      var p = Math.min((performance.now() - t0) / dur, 1);
      var ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      scroller.scrollTop = from + (to - from) * ease;
      if (p < 1) setTimeout(step, 16);
      else scroller.style.scrollBehavior = prevBehavior;
    })();
  }

  /* Buttons with data-scroll-target (capture phase survives section morphing) */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-scroll-target]');
      if (!btn) return;
      var target = document.querySelector(btn.getAttribute('data-scroll-target'));
      if (!target) return;
      e.preventDefault();
      e.stopPropagation();
      scrollToTarget(target, 900);
    },
    true
  );

  /* Hash on page load (navigation links like /#humanos from other pages) */
  function handleHashOnLoad() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var target;
    try {
      target = document.querySelector(hash);
    } catch (err) {
      return;
    }
    if (!target) return;
    /* small delay so layout (images, fonts) settles before measuring */
    setTimeout(function () {
      scrollToTarget(target, 700);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }
})();
